module.exports = __webpack_public_path__ + "img/2025.a1161bfe.png";